import { Component, ChangeDetectionStrategy, ChangeDetectorRef, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
//
import { Camp, CampProvider, Company } from '@lighty';
import { StorageService, EmitterService, TranslateService } from '@services';
//
import { CommonToastService } from '@common2/services/toast.service';
import { ComponentFormModel } from '@models/component-form.model';
import { UnpublishImpactLine } from '../../unpublish-impact-warning/unpublish-impact-warning.component';
//

@Component({
    selector: 'msc-camp-settings-general',
    templateUrl: './settings-general.component.html',
    styleUrls: ['./settings-general.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})

export class CampSettingsGeneralComponent extends ComponentFormModel {
    @Input() patch: any;
    @Output() submitEvent: EventEmitter<any> = new EventEmitter<any>();

    public company: Company;
    public camp: Camp;
    public deleteConfirmed: boolean = false;
    public deleteImpactLines: UnpublishImpactLine[] = [];
    public deleteImpactLoading: boolean = false;
    public deleteImpactFailed: boolean = false;
    public deleteImpactToken: any;

    constructor(
        protected readonly fb: FormBuilder,
        protected readonly router: Router,
        protected readonly storageService: StorageService,
        protected readonly campProvider: CampProvider,
        protected readonly toastService: CommonToastService,
        protected readonly emitterService: EmitterService,
        protected readonly translateService: TranslateService,
        protected readonly changeDetectorRef: ChangeDetectorRef,
    ) {
        super();
    }

    ngOnInit(): void {
        this.company = this.storageService.get('company')
        this.camp = this.storageService.get('camp');
        this.setFormGroup(this.patch);
    }

    /**
     * Get the form group
     */
    getFormGroup(): FormGroup {
        return this.fb.group({
            'name': [this.camp.name],
            'headline': [this.camp.headline],
            'provider': [this.camp.provider],
        });
    }

    /**
     * Eliminar el campamento da de baja a sus miembros de cursos y rutas a los que ya no llegan
     * por otro campamento: se muestra el impacto real y se exige escribir la palabra.
     */
    onOpenDelete(): void {
        this.deleteConfirmed = false;
        this.deleteImpactLines = [];
        this.deleteImpactFailed = false;
        this.deleteImpactLoading = true;
        this.deleteImpactToken = {};
        this.changeDetectorRef.markForCheck();

        this.campProvider.getDeletionImpact(this.camp.id).subscribe({
            next: (impact) => {
                this.deleteImpactLines = [
                    { labelKey: 'organize.unpublish-warning.members', value: impact.members },
                    { labelKey: 'organize.unpublish-warning.learners', value: impact.learnersAffected },
                    { labelKey: 'organize.unpublish-warning.course-enrollments', value: impact.courseEnrollments },
                    { labelKey: 'organize.unpublish-warning.traject-enrollments', value: impact.trajectEnrollments },
                ];
                this.deleteImpactLoading = false;
                this.changeDetectorRef.markForCheck();
            },
            error: () => {
                this.deleteImpactFailed = true;
                this.deleteImpactLoading = false;
                this.changeDetectorRef.markForCheck();
            },
        });
    }

    onDeleteConfirmedChange(confirmed: boolean): void {
        this.deleteConfirmed = confirmed;
        this.changeDetectorRef.markForCheck();
    }

    onConfirmDelete(modal: any): void {
        if (!this.deleteConfirmed) {
            return;
        }
        this.onDelete();
        modal.onClose();
    }

    /**
     *
     */
    onDelete(): void {
        this.campProvider.deleteCamp(this.camp.id).subscribe(() => {
            const url = `organize/${this.company.slug}/camp`;
            this.router.navigateByUrl(url);
            this.toastService.onSuccess(this.translateService.instant('toast.saved'));
            this.emitterService.set('delete.camp', null);
        });
    }

    /**
     *
     */
    onSubmit(): void {
        this.campProvider
            .updateSettings({ ...this.camp, ...this.form.value })
            .pipe()
            .subscribe({
                next: () => this.toastService.onSuccess(this.translateService.instant('toast.saved')),
                error: () => this.toastService.onSuccess(this.translateService.instant('toast.error')),
            })
    }
}
